import gsx from 'styles'

const styles = {
  root: {},

  label: {
    ...gsx.appraisalTitle,
    mt: 1,
  },

  subititle: {
    mt: 2,
    '&.MuiTypography-caption': {
      color: 'text.grey800',
    },
  },

  textField: {
    marginBottom: 2,
    borderRadius: 5,
    '& div:first-of-type': {
      boxShadow: '0 0 0 1pt #e9e9e9 !important',
    },
    '> *': {
      backgroundColor: '#fff !important',
    },
    '& input': {
      backgroundColor: 'background.default',
      borderWidth: 0,
      borderRadius: 2,
      py: 1,
      '+ div': {
        borderRight: '0 !important',
      },
      '&::placeholder': {
        color: 'text.grey300',
        opacity: '1',
      },
    },
  },

  gridContainer: {
    alignContent: 'baseline',
  },

  gridItem: {
    backgroundColor: 'transparent',
  },
  gridItemDown: {
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },
  tile: {
    backgroundColor: 'background.default',
    border: '1px solid',
    borderColor: 'text.primaryDark',
    borderRadius: 1,
    width: '100%',
    '&:hover, &.selected': {
      backgroundColor: 'primary.main',
      '& .MuiTypography-root': {
        color: (theme) => `${theme.palette.text.white}!important`,
      },
      '& svg path': {
        width: 30,
        height: 40,
        fill: 'white',
      },
      borderColor: 'primary.main',
    },

    '& .Tile-text': {
      whiteSpace: 'unset',
      '& *': {
        whiteSpace: 'unset',
      },
    },
  },

  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    px: { xs: 1, sm: 2 },
    py: { xs: 1, sm: 1.5 },
    borderRight: '1px solid #343434',
    '&.row': {
      alignItems: 'center',
    },
    '& + div': {
      textAlign: 'left',
    },
  },

  transparentIcon: {
    borderRight: '1px solid background.default',
  },

  textContainer: {
    flexGrow: 1,
    px: { xs: 1, sm: 2 },
    py: { xs: 1, sm: 1.5 },
    textAlign: 'center',
    alignSelf: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize!important',
    whiteSpace: 'nowrap',
    '& *': {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  divider: {
    width: '100%',
    paddingTop: 4,
    opacity: '.5',
  },
  dropDown: {
    position: 'relative',
    width: '100%',
  },
  dropDownButton: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: '#ABABAB',
    fontWeight: '600',
    backgroundColor: 'white',
    opacity: 0.9,
  },

  dropDownButtonContainer: {
    textAlign: 'center',
    width: '100%',
    bottom: 0,
  },
  dropDownButtonContainerUp: {
    position: 'absolute',
    pt: 10,
  },
  dropDownButtonContainerDown: {
    position: 'relative',
    pt: 4,
  },
}

export default styles
